module.exports = __webpack_public_path__ + "static/images/styles/images/icons/warning_small.58dc7a0d.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/icons/warning_small.png
// module id = 3646
// module chunks = 11